/* eslint-disable no-multiple-empty-lines */
/* eslint-disable indent */
import { RouteConfig } from 'vue-router';
// import { i18n } from '@/plugins/i18n';

// models
import { BreadCrumbModel } from '@/models/breadcrumb';

const routes: Array<RouteConfig> = [
    {
        path: '/',
        redirect: '/user-contracts',
    },
    {
        path: '/user-contracts/:page?',
        name: 'userContracts',
        component: () => import('@/views/contract-list/contract-list.component.vue'),
        meta: {
            breadcrumb: {
                text: 'العقود',
                to: { name: 'userContracts' },
                exact: true,
                link: true,
            } as BreadCrumbModel,
        },
        children: [

            {
                path: 'request-details/:id',
                name: 'requestDetails',
                component: () => import('@/views/contract-details/contract-details.component'),
                meta: {
                    breadcrumb: {
                        text: 'تفاصيل الطلب',
                    } as BreadCrumbModel,
                },
            },
            {
                path: 'issue-contract',
                name: 'issueContract',
                component: () => import('@/views/select-template/select-template.component'),
                meta: {
                    breadcrumb: {
                        text: 'إصدار عقد إلكترونيا',
                        to: { name: 'issueContract' },
                        exact: true,
                        link: true,
                    } as BreadCrumbModel,
                },
                children: [
                    {
                        path: 'partners',
                        name: 'partners',
                        component: () => import('@/views/contract-form/partners/partners.component'),
                        beforeEnter: (to, from, next) => {
                            if (from.name === 'issueContract' || from.name === 'contractDuration') next(); else next('/');
                        },
                    },
                    {
                        path: 'contract-duration',
                        name: 'contractDuration',
                        component: () => import('@/views/contract-form/contract-duration/contract-duration.component'),
                        beforeEnter: (to, from, next) => {
                            if (from.name === 'partners' || from.name === 'contractData') next(); else next('/');
                        },
                    },
                    {
                        path: 'contract-data',
                        name: 'contractData',
                        component: () => import('@/views/contract-form/contract-data/contract-data.component'),
                        beforeEnter: (to, from, next) => {
                            if (from.name === 'contractDuration' || from.name === 'previewContract') next(); else next('/');
                        },
                    },
                    {
                        path: 'preview-contract',
                        name: 'previewContract',
                        component: () => import('@/views/contract-form/preview-contract/preview-contract.component'),
                        beforeEnter: (to, from, next) => {
                            if (from.name === 'contractData') next(); else next('/');
                        },
                    },
                ],
            },
        ],
    },
    {
        path: '/contract-verification',
        name: 'contractVerification',
        component: () => import('@/views/contract-verification/contract-verification-search.component.vue'),
        meta: {
            breadcrumb: {
                text: 'التحقق من وثيقة العقد',
                to: { name: 'contractVerification' },
                exact: true,
                link: true,
            } as BreadCrumbModel,
        },
        children: [
            {
                path: 'result',
                name: 'contractVerificationResult',
                component: () => import('@/views/contract-verification/contract-verification-result.component.vue'),
                meta: {
                    breadcrumb: {
                        text: 'نتيجة التحقق',
                    } as BreadCrumbModel,
                },
                beforeEnter: (to, from, next) => {
                    if (from.name === 'contractVerification') next(); else next({ name: 'contractVerification' });
                },
            },
        ],
    },

    {


        path: '/contract-details/:id',
        name: 'contractDetails',
        component: () => import('@/views/contract-details/contract-details.component'),
        meta: {
            breadcrumb: {
                text: 'تفاصيل العقد',
                to: { name: 'contractDetails' },
                exact: true,
                link: true,
            } as BreadCrumbModel,
        },

    },
    // {
    //   path: '/[route]',
    //   name: '[Test-Component]',
    //   component: Test,
    //   meta: {
    //     breadcrumb: {
    //       text: i18n.t('[Your_Breadcrumb_Text from i18n]'),
    //       href: '/[Route_Path ====> [route] ]',
    //     } as BreadCrumbModel,
    //   },
    // },
];

export default routes;
